/**
 * Options for quickshop from category
 */
export const categoryQuickshopOptions = {
    ownerView: false,
    shopperView: false,

    wrapPagination: false,
    showAddToRegistry: true,
    showAddToWishlist: true,

    hideSocial: true,
    hideSizeGuide: true,
    hideRequestSwatch: true,
    collapseAccordions: true,
    disableAutoFocus: true
};
